import { render, staticRenderFns } from "./ProCard.vue?vue&type=template&id=a434641a&scoped=true"
import script from "./ProCard.vue?vue&type=script&lang=js"
export * from "./ProCard.vue?vue&type=script&lang=js"
import style0 from "./ProCard.vue?vue&type=style&index=0&id=a434641a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a434641a",
  null
  
)

export default component.exports